import React, { type SVGProps } from 'react';
const SvgReligiousProfessional = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width={29.336} viewBox="0 0 29.336 29.34" {...props}>
            <g
                stroke="#000"
                strokeWidth={0.85}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g fill="#ffcd27">
                    <rect x={3.3} y={0.8} width={2.6} height={6} rx={1.3} />
                    <rect x={23.436} y={0.8} width={2.6} height={6} rx={1.3} />
                    <rect x={3.3} y={22.54} width={2.6} height={6} rx={1.3} />
                    <rect
                        x={23.436}
                        y={22.54}
                        width={2.6}
                        height={6}
                        rx={1.3}
                    />
                </g>
                <path
                    d="M6.6 5.7q8.068-2.2 16.136 0V24Q14.668 21.8 6.6 24Z"
                    fill="#fff5f4"
                />
                <path
                    d="M6.6 21.8q8.068-2.2 16.136 0V24Q14.668 21.8 6.6 24Z"
                    fill="#ebe0da"
                    stroke="none"
                />
                <path d="M6.6 24q8.068-2.2 16.136 0" fill="none" />
                <g fill="#12b05e">
                    <rect x={2.6} y={4.8} width={4} height={19.74} rx={2} />
                    <rect x={22.736} y={4.8} width={4} height={19.74} rx={2} />
                </g>
                <path d="M4.6 7.3v14.5M24.736 7.3v14.5" stroke="#f9f9fb" />
                <g fill="none">
                    <path d="m14.668 8.5 4.1 7.1h-8.2Zm0 9.5-4.1-7.1h8.2ZM10.5 20h8.336" />
                </g>
            </g>
        </svg>
    );
};
export default SvgReligiousProfessional;
